import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../utility';

const initialState = {
    // calendar info
    calendar_id: null,
    // friend_calendar_id keep track of the last friend's calendar_id, 
    // in case of view my calendar overwrite the friend_calendar_id
    friend_calendar_id: null,
    availabilities: [],
    calendar_meta: {},
    selected_availability: null,
    last_booked_appointment: null,
    // book info
    name: null,
    extra: null,
    // control flow
    step: 'get',
};

const scheduleGet = ( state, action ) => {
    if (action.friend_calendar_id) {
        return updateObject( state, 
            { 
                // calendar
                calendar_id: action.calendar_id,
                friend_calendar_id: action.friend_calendar_id,
                availabilities: action.availabilities,
                calendar_meta: action.calendar_meta,
                selected_availability: null,
                // book
                name: null,
                extra: null,
                // step
                step: 'get',
            } 
        );
    }
    else {
        return updateObject( state, 
            { 
                // calendar
                calendar_id: action.calendar_id,
                availabilities: action.availabilities,
                calendar_meta: action.calendar_meta,
                selected_availability: null,
                // book
                name: null,
                extra: null,
                // step
                step: 'get',
            } 
        );
    }
};

const schedulePick = ( state, action ) => {

    return updateObject( state, 
        { 
            // calendar
            selected_availability: action.selected_availability,
        } 
    );
};

const scheduleSelect = ( state, action ) => {

    return updateObject( state, 
        { 
            // calendar
            selected_availability: action.selected_availability,
            // step
            step: 'select',
        } 
    );
};

const scheduleBook = ( state, action ) => {
    console.log(action);
    return updateObject( state, 
        { 
            // calendar
            selected_availability: null,
            last_booked_appointment: action.last_booked_appointment,
            // book
            name: null,
            extra: null,
            // step
            step: 'book',
        } 
    );
};

const reducer = ( state = initialState, action ) => {
    switch ( action.type ) {
        case actionTypes.SCHEDULE_GET: return scheduleGet(state, action);
        case actionTypes.SCHEDULE_PICK: return schedulePick(state, action);
        case actionTypes.SCHEDULE_SELECT: return scheduleSelect(state, action);
        case actionTypes.SCHEDULE_BOOK: return scheduleBook(state, action);
        default:
            return state;
    }
};

export default reducer;


// WEBPACK FOOTER //
// ./src/store/reducers/schedule.js